import useAppLoadAsyncOperations from './useAppLoadAsyncActions';

/**
 * Null-rendering shell mount for the app-load async polling loop.
 *
 * `useAppLoadAsyncOperations` polls the user's active generation jobs, which
 * triggers the backend status sync -> post_save signal -> Ably publish, and
 * registers active jobs with the AsyncProcessor for in-progress UI. It used to
 * be mounted by the now-deleted Main layout; mounting it once here at the app
 * shell restores that polling for both the firm and workboard shells. `addJob`
 * dedupes by job id, so a single mount is safe.
 */
const AppLoadAsyncOperations = () => {
  useAppLoadAsyncOperations();
  return null;
};

export default AppLoadAsyncOperations;
